import { RpcRequest } from '@dealroadshow/json-rpc-dispatcher';

export default class Request extends RpcRequest {
  constructor(method: string, payload?: object, headers?: object) {
    super({ method, params: { headers, payload } });
  }
}
